import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { MdEdit } from "react-icons/md";
import AccessRightService from "../services/AccessRightService";
import WarehouseMasterService from "../services/WarehouseMasterService";

const User = ({ isLoggedIn }) => {
  const accessRightService = new AccessRightService();
  const warehouseMasterService = new WarehouseMasterService();
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const [formData, setFormData] = useState({
    Username: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    location: "",
    IsActive: true,
    UserType: "", // Added UserType state with default value 'Admin'
    WarehouseOptions: [], // Added state to store options for the Warehouse dropdown
    SelectedWarehouse: "" // Added state to store selected warehouse
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [formErrors, setFormErrors] = useState({
    Username: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    location: "",
    UserType: "",
    SelectedWarehouse: ""
  });

  const openDialog = (isAdd) => {
    if (isAdd) {
      setShowDialog(true);
      setSelectedRow(null);
    } else {
      setShowDialog(true);
    }
  };

  const handleDialogOpen = (row) => {
    const editMode = async () => {
      setSelectedRow(row);
      if (row) {
        // For editing existing user
        setFormData({
          Username: row.username || "",
          email: row.email || "",
          MobNo: row.mobileNo || "",
          password: row.password || "",
          Cpassword: row.password || "",
          location: row.location || "",
          IsActive: row.isActive || false,
          UserType: row.userType || "",
          SelectedWarehouse: row.wareHouseId || ""
        });

        if (row.userType === "1") {
          // Fetch warehouse options before opening dialog if UserType is '1' (Warehouse)
          await fetchWarehouseOptions();
        }
        openDialog(false);
      } else {
        // For adding new user
        setFormData({
          Username: "",
          email: "",
          MobNo: "",
          password: "",
          Cpassword: "",
          location: "",
          IsActive: false,
          UserType: "",
          SelectedWarehouse: ""
        });
        openDialog(true);
      }
    };

    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
            rounded text-sm hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "IsActive":
        setFormData((prevData) => ({
          ...prevData,
          IsActive: event.target.checked
        }));
        break;
      default:
        break;
    }
    validateForm(name, value);
  };

  // Function to fetch options for the Warehouse dropdown based on UserType
  const fetchWarehouseOptions = async () => {
    try {
      warehouseMasterService.GetWarehouseDDL().then((response) => {
        if (response && response.responseData) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            WarehouseOptions: response.responseData
          }));
        } else {
          toast.error(
            response.data.responseMessage || "Failed to fetch warehouse options"
          );
        }
      });
    } catch (error) {
      console.error("Failed to fetch warehouse options:", error);
      toast.error("Failed to fetch warehouse options");
    }
  };

  // useEffect to fetch warehouse options when UserType is 'Warehouse'
  useEffect(() => {
    if (formData.UserType === "1") {
      fetchWarehouseOptions();
    }
  }, [formData.UserType]);

  // Render Warehouse dropdown if UserType is 'Warehouse'
  const renderWarehouseDropdown = () => {
    if (
      formData.UserType === "1" &&
      Array.isArray(formData.WarehouseOptions) &&
      formData.WarehouseOptions.length > 0
    ) {
      return (
        <div>
          <FormControl fullWidth error={!!formErrors.SelectedWarehouse}>
            <InputLabel id="warehouse-label">Select Warehouse</InputLabel>
            <Select
              labelId="warehouse-label"
              value={formData.SelectedWarehouse}
              onChange={handleFormChange}
              name="SelectedWarehouse"
            >
              {formData.WarehouseOptions.map((warehouse) => (
                <MenuItem key={warehouse.value} value={warehouse.value}>
                  {warehouse.label}
                </MenuItem>
              ))}
            </Select>
            {!!formErrors.SelectedWarehouse && (
              <FormHelperText>{formErrors.SelectedWarehouse}</FormHelperText>
            )}
          </FormControl>
        </div>
      );
    }
    return null;
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "Username":
        if (value.length < 1) {
          IsValid = false;
          errors.Username = "Please enter user name.";
        } else errors.Username = "";
        break;
      case "UserType":
        if (value.length < 1) {
          IsValid = false;
          errors.UserType = "Please select user type.";
        } else errors.UserType = "";
        break;
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter email-id.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email-id.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "MobNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobNo = "Please enter mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = true;
            errors.MobNo = "Please enter valid mobile no.";
          } else errors.MobNo = "";
        } else errors.MobNo = "";
        break;
      case "password":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.password = "Please enter password.";
        } else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
          IsValid = false;
          errors.password =
            "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
        } else if (
          !value &&
          value.length >= 1 &&
          formData.Cpassword.length >= 1
        ) {
          errors.password = "";
          errors.Cpassword = "";
          if (!(value === formData.Cpassword)) {
            IsValid = false;
            errors.password = "password does not match";
          } else errors.password = "";
        } else errors.password = "";
        break;
      case "SelectedWarehouse":
        if (formData.UserType === "1" && value === "") {
          IsValid = false;
          errors.SelectedWarehouse = "Warehouse is required";
        } else errors.SelectedWarehouse = "";
        break;
      case "Cpassword":
        if (!value && value.length < 1) {
          IsValid = false;
          errors.Cpassword = "Please enter confirm password.";
        } else if (value.length >= 1 && formData.password.length >= 1) {
          errors.password = "";
          errors.Cpassword = "";
          if (value !== formData.password) {
            IsValid = false;
            errors.Cpassword =
              "New password and Confirm password should be same.";
          }
        } else if (
          !value &&
          value.length >= 1 &&
          formData.password.length >= 1
        ) {
          errors.password = "";
          errors.Cpassword = "";
          if (!(value === formData.password)) {
            IsValid = false;
            errors.Cpassword = "Confirm password does not match";
          } else errors.Cpassword = "";
        } else errors.Cpassword = "";
        break;
      case "location":
        if (value.length < 1) {
          IsValid = false;
          errors.location = "location is required.";
        } else errors.location = "";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const closeDialog = () => {
    setShowDialog(false);
    Getuser();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      if (selectedRow) {
        // Editing existing user
        try {
          setState((prevData) => ({
            ...prevData,
            loading: true
          }));

          const userData = {
            UserId: selectedRow.userId,
            Username: formData.Username,
            email: formData.email,
            MobileNo: formData.MobNo,
            IsActive: formData.IsActive,
            location: formData.location,
            password: formData.password,
            Cpassword: formData.Cpassword,
            UserType: formData.UserType,
            SelectedWarehouse: formData.SelectedWarehouse
          };

          accessRightService.CreateUpdateUser(userData).then((response) => {
            setState((prevData) => ({
              ...prevData,
              loading: false
            }));
            if (response && response.responseCode === "200") {
              toast.success("User Updated Successfully!");
              setFormData({
                Username: "",
                email: "",
                MobNo: "",
                password: "",
                Cpassword: "",
                location: "",
                IsActive: false,
                UserType: "",
                SelectedWarehouse: ""
              });
              setSelectedRow(null);
              setShowDialog(false);
            } else if (response.responseCode === "400") {
              toast.error(response.responseMessage);
            }
          });
        } catch (error) {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("User Update failed:", error);
          toast.error(error.message);
        }
      } else {
        // Creating new user
        try {
          setState((prevData) => ({
            ...prevData,
            loading: true
          }));

          const userData = {
            Username: formData.Username,
            email: formData.email,
            MobileNo: formData.MobNo,
            password: formData.password,
            Cpassword: formData.Cpassword,
            IsActive: formData.IsActive,
            location: formData.location,
            UserType: formData.UserType,
            SelectedWarehouse: formData.SelectedWarehouse
          };

          accessRightService.CreateUpdateUser(userData).then((response) => {
            setState((prevData) => ({
              ...prevData,
              loading: false
            }));

            if (response.responseCode === "200") {
              toast.success("User Create Successfully!");
              setFormData({
                Username: "",
                email: "",
                MobNo: "",
                password: "",
                Cpassword: "",
                location: "",
                IsActive: false,
                UserType: "",
                SelectedWarehouse: ""
              });
            } else if (response.responseCode === "400") {
              toast.error(response.responseMessage);
            }
          });
        } catch (error) {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("User Creation failed:", error);
          toast.error(error.message);
        }
      }
      closeDialog();
    }
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    Getuser();
  }, [isLoggedIn, navigate]);

  function Getuser() {
    accessRightService.GetUsers(tableRequest).then((response) => {
      if (
        response &&
        response.responseData &&
        response.responseData.length > 0
      ) {
        const sales = response.responseData.slice(0, tableRequest.PageSize);
        setState((prevData) => ({
          ...prevData,
          datasource: response.responseData,
          totalRecords: response.responseData[0].totalRows,
          sales,
          loading: false
        }));
      } else {
        setState((prevData) => ({
          ...prevData,
          datasource: [],
          totalRecords: 0,
          sales: [],
          loading: false
        }));
      }
    });
  }
  const initialFormData = {
    Username: "",
    email: "",
    MobNo: "",
    password: "",
    Cpassword: "",
    location: "",
    UserType: "",
    SelectedWarehouse: "",
    IsActive: true
  };
  const handleDialogClose = () => {
    setShowDialog(false);
    setFormData(initialFormData);
    setFormErrors({
      Username: "",
      email: "",
      MobNo: "",
      password: "",
      Cpassword: "",
      location: "",
      UserType: "",
      SelectedWarehouse: ""
    });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    Getuser();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    Getuser();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    Getuser();
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          User Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <button
          onClick={openDialog}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 
                    rounded focus:outline-none focus:shadow-outline"
          type="button"
        >
          (+) Add
        </button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="UserMaster"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="username"
                    header="User Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="mobileNo"
                    header="Mobile Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="email"
                    header="Email"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="createdDt"
                    header="Created Date"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={handleDialogOpen}
                    header="Action"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>
          <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            PaperProps={{ style: { backgroundColor: "black" } }}
            className="add"
          >
            <DialogTitle style={{ color: "white", textAlign: "center" }}>
              {selectedRow ? "Update User" : "Add User"}
            </DialogTitle>
            <form onSubmit={handleFormSubmit}>
              <DialogContent>
                <TextField
                  margin="dense"
                  label="User Name"
                  type="text"
                  name="Username"
                  autoComplete="off"
                  value={formData.Username}
                  onChange={handleFormChange}
                  placeholder="Enter User Name"
                  fullWidth
                  error={!!formErrors.Username}
                  helperText={formErrors.Username}
                />
                <TextField
                  margin="dense"
                  label="User Type"
                  select
                  name="UserType"
                  value={formData.UserType}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.UserType}
                  helperText={formErrors.UserType}
                >
                  <MenuItem value="0">Admin</MenuItem>
                  <MenuItem value="1">Warehouse</MenuItem>
                </TextField>
                {/* Render Warehouse dropdown if UserType is Warehouse */}
                {renderWarehouseDropdown()}

                <TextField
                  margin="dense"
                  label="Email"
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  placeholder="Enter Email"
                  fullWidth
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                />
                <TextField
                  margin="dense"
                  label="Mobile Number"
                  type="text"
                  name="MobNo"
                  value={formData.MobNo}
                  onChange={handleFormChange}
                  placeholder="Enter Mobile No."
                  fullWidth
                  error={!!formErrors.MobNo}
                  helperText={formErrors.MobNo}
                />
                <TextField
                  margin="dense"
                  label="Password"
                  type="password"
                  name="password"
                  autoComplete="off"
                  value={formData.password}
                  onChange={handleFormChange}
                  placeholder="Enter Password "
                  fullWidth
                  error={!!formErrors.password}
                  helperText={formErrors.password}
                />
                <TextField
                  margin="dense"
                  label="Confirm Password"
                  type="password"
                  autoComplete="off"
                  name="Cpassword"
                  value={formData.Cpassword}
                  onChange={handleFormChange}
                  placeholder="Enter Confirm password"
                  fullWidth
                  error={!!formErrors.Cpassword}
                  helperText={formErrors.Cpassword}
                />
                <TextField
                  margin="dense"
                  label="Location"
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleFormChange}
                  placeholder="Enter Location"
                  fullWidth
                  error={!!formErrors.location}
                  helperText={formErrors.location}
                />
                <div className="row">
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.IsActive}
                          onChange={handleFormChange}
                          name="IsActive"
                          color="primary"
                        />
                      }
                      label="Active"
                      error={!!formErrors.IsActive}
                      helperText={formErrors.IsActive}
                    />
                  </div>
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};
export default User;
